module.exports = __webpack_public_path__ + "img/close.df10d263.svg";